var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFast15(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20 10 6.857 2.948L21.241 18l-.442-2.848C16.365 15.953 13 19.834 13 24.499 13 29.744 17.254 34 22.499 34 27.745 34 32 29.745 32 24.499a1 1 0 0 1 2 0C34 30.849 28.85 36 22.499 36 16.149 36 11 30.849 11 24.499c0-5.665 4.099-10.375 9.492-11.324L20 10zm7.676 9.812v1.82h-3.67l-.205 1.457c.204-.03.379-.03.612-.03.903 0 1.82.204 2.492.684.715.482 1.15 1.268 1.15 2.375 0 1.764-1.515 3.322-4.066 3.322-1.15 0-2.11-.263-2.633-.538l.39-1.663c.424.206 1.284.466 2.145.466.916 0 1.891-.435 1.891-1.44 0-.978-.77-1.574-2.664-1.574-.527 0-.89.03-1.282.087l.625-4.966h5.215zM20 20v9h-1.973v-7.132H18l-1.665.816L16 21.108 18.31 20H20z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFast15);
export default __webpack_public_path__ + "static/media/fast15.5ee84d5e3cb564d4aa38b12c87a9afd6.svg";
export { ForwardRef as ReactComponent };